export const parseFlexibleDateValue = (value) => {
  if (value === null || value === undefined || value === '') return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    const numericDate = new Date(value);
    return Number.isNaN(numericDate.getTime()) ? null : numericDate;
  }

  if (typeof value === 'object') {
    if (typeof value.toDate === 'function') {
      const timestampDate = value.toDate();
      if (timestampDate instanceof Date && !Number.isNaN(timestampDate.getTime())) {
        return timestampDate;
      }
    }

    const seconds = Number(value.seconds ?? value._seconds);
    const nanoseconds = Number(value.nanoseconds ?? value._nanoseconds);
    if (Number.isFinite(seconds)) {
      const millisFromSeconds = seconds * 1000 + (Number.isFinite(nanoseconds) ? Math.floor(nanoseconds / 1000000) : 0);
      const timestampDate = new Date(millisFromSeconds);
      if (!Number.isNaN(timestampDate.getTime())) {
        return timestampDate;
      }
    }

    const millis = Number(
      value.milliseconds ??
      value._milliseconds ??
      value.epochMillis ??
      value.epochMilliseconds
    );
    if (Number.isFinite(millis)) {
      const millisDate = new Date(millis);
      if (!Number.isNaN(millisDate.getTime())) {
        return millisDate;
      }
    }
  }

  const raw = String(value).trim();
  if (!raw) return null;

  if (/^\d{10,13}$/.test(raw)) {
    const numeric = Number(raw);
    if (Number.isFinite(numeric)) {
      const timestampDate = new Date(raw.length === 10 ? numeric * 1000 : numeric);
      if (!Number.isNaN(timestampDate.getTime())) {
        return timestampDate;
      }
    }
  }

  const ymdMatch = raw.match(/^(\d{4})[/.-](\d{1,2})[/.-](\d{1,2})$/);
  if (ymdMatch) {
    const year = Number(ymdMatch[1]);
    const month = Number(ymdMatch[2]);
    const day = Number(ymdMatch[3]);
    const parsedYmd = new Date(year, month - 1, day);
    if (
      !Number.isNaN(parsedYmd.getTime()) &&
      parsedYmd.getFullYear() === year &&
      parsedYmd.getMonth() === month - 1 &&
      parsedYmd.getDate() === day
    ) {
      return parsedYmd;
    }
  }

  const dmyOrMdyMatch = raw.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{2,4})$/);
  if (dmyOrMdyMatch) {
    const first = Number(dmyOrMdyMatch[1]);
    const second = Number(dmyOrMdyMatch[2]);
    const rawYear = Number(dmyOrMdyMatch[3]);
    const year = rawYear < 100 ? (rawYear >= 70 ? rawYear + 1900 : rawYear + 2000) : rawYear;

    let day = first;
    let month = second;

    if (first <= 12 && second > 12) {
      day = second;
      month = first;
    } else if (first > 12 && second <= 12) {
      day = first;
      month = second;
    } else {
      day = first;
      month = second;
    }

    const parsed = new Date(year, month - 1, day);
    if (
      !Number.isNaN(parsed.getTime()) &&
      parsed.getFullYear() === year &&
      parsed.getMonth() === month - 1 &&
      parsed.getDate() === day
    ) {
      return parsed;
    }
  }

  const directDate = new Date(raw);
  return Number.isNaN(directDate.getTime()) ? null : directDate;
};

export const formatDateForInput = (dateValue) => {
  const parsedDate = parseFlexibleDateValue(dateValue);
  if (!parsedDate) return '';
  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
  const day = String(parsedDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getDateLocaleForCountry = (countryInput) => {
  const rawValue = typeof countryInput === 'string'
    ? countryInput
    : (countryInput?.id || countryInput?.name || '');
  const normalized = String(rawValue || '').trim().toLowerCase();

  if (normalized === 'us' || normalized === 'usa' || normalized.includes('united states')) {
    return 'en-US';
  }
  if (normalized === 'ie' || normalized.includes('ireland')) {
    return 'en-IE';
  }
  if (normalized === 'uk' || normalized === 'gb' || normalized.includes('united kingdom')) {
    return 'en-GB';
  }
  return 'en-GB';
};

export const formatDisplayDate = (dateValue, locale = 'en-GB', fallback = 'Unknown') => {
  const parsedDate = parseFlexibleDateValue(dateValue);
  if (!parsedDate) return fallback;
  return parsedDate.toLocaleDateString(locale);
};

export const getDateSortTime = (dateValue) => {
  const parsedDate = parseFlexibleDateValue(dateValue);
  return parsedDate ? parsedDate.getTime() : 0;
};
